var React = require('react');

function ContractsIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#131416","fillRule":"evenodd","d":"M2 1h20v22H2V1Zm2 2v18h16V3H4Zm14 14H6v2h12v-2ZM14.328 5.55l2.122 2.122-5.778 5.778-2.122-2.122 5.778-5.778ZM10 15l-3-3v3h3Z","clipRule":"evenodd"}));
}

ContractsIconInline.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = ContractsIconInline;

ContractsIconInline.default = ContractsIconInline;
